import { defineComponent as _defineComponent } from 'vue'
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeHeroActionsLoader',
  setup(__props) {


return { __sfc: true,SkeletonLoader }
}

})